var _path, _g, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoanWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1045_611",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 9,
    width: 37,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.51 9H7V41.5982H43.51V9Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1045_611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.9489 10.3036H10.9145C9.47422 10.3036 8.30664 11.4712 8.30664 12.9114V17.4752M8.30664 17.4752V37.0342C8.30664 38.4745 9.47422 39.642 10.9145 39.642H39.6009C41.0413 39.642 42.2087 38.4745 42.2087 37.0342V20.0831C42.2087 18.6428 41.0413 17.4752 39.6009 17.4752H8.30664Z",
    stroke: "#FF000C",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3373 24.9728H42.5309V32.1444H36.3373C34.3569 32.1444 32.7515 30.5389 32.7515 28.5586C32.7515 26.5781 34.3569 24.9728 36.3373 24.9728Z",
    stroke: "#FF000C",
    strokeWidth: 3
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 10,
    fill: "#FF000C",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1043 9C18.8806 9.34921 18.6537 9.69625 18.4355 10.0487C18.3771 10.1433 18.3123 10.1781 18.2012 10.1766C17.7072 10.1712 17.213 10.1752 16.719 10.1756C16.653 10.1757 16.587 10.1756 16.5017 10.1756C16.6543 10.5059 16.7931 10.8201 16.9483 11.1258C16.9703 11.1694 17.0719 11.1906 17.137 11.1912C17.692 11.196 18.2473 11.194 18.8025 11.194C18.869 11.194 18.936 11.194 19.0389 11.194C18.966 11.3178 18.9114 11.4222 18.8462 11.5194C18.6832 11.7627 18.5229 12.0084 18.3449 12.2404C18.2955 12.3046 18.1893 12.3558 18.1071 12.3587C17.7543 12.3718 17.4008 12.3644 17.0376 12.3644C17.0182 12.4219 16.9988 12.4715 16.9846 12.5225C16.7451 13.3812 16.2048 13.9915 15.4155 14.3773C14.7867 14.6845 14.1209 14.8788 13.4183 14.9295C13.3965 14.9311 13.3751 14.9389 13.3251 14.9501C14.7721 16.6285 16.2044 18.2899 17.6571 19.9749C17.5764 19.9807 17.5254 19.9878 17.4744 19.9878C16.956 19.9885 16.4373 19.9829 15.919 19.9916C15.7713 19.9941 15.6693 19.9498 15.5719 19.8401C14.7076 18.8691 13.8389 17.9019 12.9715 16.9336C12.4868 16.3924 11.9988 15.8545 11.5211 15.3075C11.4565 15.2335 11.4166 15.1157 11.4115 15.0158C11.397 14.7308 11.4064 14.4446 11.4064 14.1448C11.7224 14.1448 12.0193 14.1564 12.3149 14.1417C12.6435 14.1254 12.9729 14.1001 13.2982 14.053C14.0087 13.9503 14.5978 13.6146 15.0613 13.0673C15.2495 12.8449 15.375 12.5893 15.378 12.2665H11.0352C11.0652 12.1984 11.0774 12.1537 11.102 12.1174C11.2799 11.8548 11.4624 11.5952 11.6388 11.3316C11.7033 11.2351 11.7826 11.2033 11.8988 11.2036C12.9236 11.208 13.9485 11.2064 14.9733 11.2064C15.0399 11.2064 15.1065 11.2064 15.1988 11.2064C15.1364 10.9809 14.993 10.8468 14.8255 10.7359C14.4526 10.4893 14.0355 10.333 13.5991 10.2861C12.8611 10.2069 12.1178 10.1763 11.3766 10.1276C11.2629 10.1202 11.1483 10.1267 11 10.1267C11.2615 9.73243 11.5045 9.36622 11.7475 9C14.1998 9 16.6521 9 19.1043 9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanWallet);
export default __webpack_public_path__ + "static/media/LoanWallet.2953c23572545dc9d5b43d2e89bfdf38.svg";
export { ForwardRef as ReactComponent };